import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { ITokenResponseData, IDevice, IJob, IRole, IClientSettings } from '../api/interfaces';
import { INetworkError, IUnacknowledgedAlarmsReceivedArgs } from './interfaces';

@Injectable({
  providedIn: 'root'
})
export class ObservablesService {
  private authenticated = new Subject<ITokenResponseData>();
  private networkResponseError = new Subject<INetworkError>();
  private jobUpdated = new Subject<IJob>();
  private deviceUpdated = new Subject<IDevice>();
  private jobTokenRetrieved = new BehaviorSubject<string>(null!);
  private roleUpdated = new Subject<IRole>();
  private roleDeleted = new Subject<string>();
  private clientSettings = new ReplaySubject<IClientSettings>(1);
  private unacknowledgedAlarmsReceived = new BehaviorSubject<IUnacknowledgedAlarmsReceivedArgs>({ count: 0 });
  private menuToggle = new BehaviorSubject<boolean>(true);

  setmenuToggle(value: boolean) {
    this.menuToggle.next(value);
  }

  getmenuToggleStatus():Observable<boolean> {
    return this.menuToggle.asObservable();
  }

  setUnacknowledgedAlarmsReceived(args: IUnacknowledgedAlarmsReceivedArgs): void {
    this.unacknowledgedAlarmsReceived.next(args);
  }

  getUnacknowledgedAlarms(): Observable<IUnacknowledgedAlarmsReceivedArgs> {
    return this.unacknowledgedAlarmsReceived.asObservable();
  }

  setClientSettings(clientSettings: IClientSettings): void {
    this.clientSettings.next(clientSettings);
  }

  getClientSettings(): Observable<IClientSettings> {
    return this.clientSettings.asObservable();
  }

  setRoleDeleted(roleId: string): void {
    this.roleDeleted.next(roleId);
  }

  getRoleDeleted(): Observable<string> {
    return this.roleDeleted.asObservable();
  }

  setRoleUpdated(role: IRole): void {
    this.roleUpdated.next(role);
  }

  getRoleUpdated(): Observable<IRole> {
    return this.roleUpdated.asObservable();
  }

  setJobTokenRetrieved(jobToken: string): void {
    this.jobTokenRetrieved.next(jobToken);
  }

  getJobTokenRetrieved(): Observable<string> {
    return this.jobTokenRetrieved.asObservable();
  }

  setDeviceUpdated(device: IDevice): void {
    this.deviceUpdated.next(device);
  }

  getDeviceUpdated(): Observable<IDevice> {
    return this.deviceUpdated.asObservable();
  }

  setJobUpdated(job: IJob): void {
    this.jobUpdated.next(job);
  }

  getJobUpdated(): Observable<IJob> {
    return this.jobUpdated.asObservable();
  }

  setNetworkResponseError(networkError: INetworkError): void {
    this.networkResponseError.next(networkError);
  }

  getNetworkResponseError(): Observable<INetworkError> {
    return this.networkResponseError.asObservable();
  }

  setAuthenticated(tokenResponseData: ITokenResponseData): void {
    this.authenticated.next(tokenResponseData);
  }

  getAuthenticated(): Observable<ITokenResponseData> {
    return this.authenticated.asObservable();
  }
}
